mutation verifySoftwareToken($userCode: String!, $deviceName: String) {
  verifySoftwareToken(userCode: $userCode, deviceName: $deviceName) {
    verified
  }
}
